import { maxLength, required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import axios from "axios";
import CONFIG from "@/assets/js/config.js";
import pdfIcon from '@/assets/images/pdf.png';
import docIcon from '@/assets/images/doc.png';
import pptIcon from '@/assets/images/ppt.png';

export default {
  props: {
    answerId: Number
  },

  data() {
    return {
      editAnswer: {},
      submitted: false,
      submit_permission: false,
      disabled: false,
      CONFIG,
      pdfIcon,
      docIcon,
      pptIcon,
      new_files: [],
      existing_files: [],
      status: 0,
    };
  },

  validations: {
    editAnswer: {
      description: {
        required,
        maxLength: maxLength(200)
      },
      remark: {
        maxLength: maxLength(5000)
      },
    }
  },

  computed: {
    ...mapGetters(["userType", "studentId"])
  },

  methods: {
    getDetail() {
      axios.get(`my/assignment/answer/detail/${this.answerId}`)
        .then(res => {
          this.editAnswer = res.data;
          this.editAnswer.deleted_exist_file = [];
          this.existing_files = this.editAnswer.assignment_files;
          this.existing_files.forEach((file, index) => {
            this.existing_files[index].type = file.name.split('.')[1];
          });
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('/');
          }
          console.log(error);
        });
    },

    update() {
      if (this.disabled) return;
      this.disabled = true;
      this.submitted = true;
      this.submit_permission = false;
      if (this.$v.editAnswer.$invalid) {
        this.disabled = false;
        return;
      }

      let formData = new FormData();
      formData.append('description', this.editAnswer.description);
      formData.append('remark', this.editAnswer.remark ?? '');
      formData.append('status', this.status);
      this.editAnswer.deleted_exist_file.forEach(id => {
        formData.append('deleted_exist_file[]', id);
      });

      if (this.new_files.length) {
        this.new_files.forEach(fileObj => {
          formData.append('files[]', fileObj.file);
        });
      }

      axios.post(`my/assignment/answer/update/${this.answerId}`, formData)
        .then(() => {
          this.changeSection();
          this.$notification.success("Assignment ပြင်ဆင်ခြင်းအောင်မြင်ပါသည်။", {
            timer: 3,
            position: "bottomCenter"
          });
        })
        .catch((error) => {
          if (error && error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('/');
          }
          console.log("Update Answer API Error", error);
        })
        .finally(() => {
          this.disabled = false;
        });
    },

    chooseFiles(id) {
      document.getElementById(id).click();
    },

    onFileChange(e) {
      const selectedFiles = e.target.files;
      if (!selectedFiles || !selectedFiles.length) return;

      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles[i];

        const fileExtension = file.name.split('.').pop().toLowerCase();

        if (!CONFIG.ASSIGNMENT.ALLOWED_FILE_TYPES.includes(file.type) || fileExtension === 'jfif') {
          this.$notification.error(CONFIG.ASSIGNMENT.ERROR.Type, {
            timer: 3,
            position: "bottomCenter",
          });
          continue;
        }

        if (file.size > CONFIG.ASSIGNMENT.MAX_FILE_SIZE) {
          this.$notification.error(CONFIG.ASSIGNMENT.ERROR.Max_Size, {
            timer: 3,
            position: "bottomCenter",
          });
          continue;
        }

        if ((this.new_files.length + this.existing_files.length) >= CONFIG.ASSIGNMENT.MAX_FILE_COUNT) {
          this.$notification.error(CONFIG.ASSIGNMENT.ERROR.Max_Count, {
            timer: 3,
            position: "bottomCenter",
          });
          return;
        }

        const nameLower = file.name.toLowerCase();
        const existsOld = this.existing_files.some(f => (f.name || '').toLowerCase() === nameLower);
        const existsNew = this.new_files.some(f => (f.name || '').toLowerCase() === nameLower);

        if (existsOld || existsNew) {
          this.$notification.error(`"${file.name}" is already added.`, {
            timer: 3,
            position: "bottomCenter",
          });
          continue;
        }

        const fileObj = {
          file: file,
          name: file.name,
          type: file.type,
          data: null
        };
        this.new_files.push(fileObj);

        if (file.type.match(/image/i)) {
          const reader = new FileReader();
          reader.onload = () => {
            fileObj.data = reader.result;
          };
          reader.readAsDataURL(file);
        }
      }

      const inputEl = document.getElementById('answer-file');
      if (inputEl) inputEl.value = null;
    },

    removeFile(i, oldFileId) {
      if (oldFileId) {
        this.editAnswer.deleted_exist_file.push(oldFileId);
        this.existing_files.splice(i, 1);
      } else {
        this.new_files.splice(i, 1);
        const inputEl = document.getElementById('answer-file');
        if (inputEl) inputEl.value = null;
      }
    },

    confirmRemoveFile(i, oldFileId) {
      const message = 'ဤ File ကို ဖျက်ရန် သေချာပါသလား?';
      if (window.confirm(message)) {
        this.removeFile(i, oldFileId);
      }
    },

    changeSection() {
      this.$emit('changeSection', 'AssignmentAnswerList');
    }
  },

  mounted() {
    this.getDetail();
  },
};
